import React, { useMemo } from 'react';
import useServiceBulletinReport from './hooks/useServiceBulletinReport';
import ServiceBulletinTable from './components/ServiceBulletinReportTable';
import { useLanguage } from '../../../contexts/LanguageContext';
import { getServiceBulletinColumns } from './helpers/getServiceBulletinColumns';
import ServiceBulletinFilters from './components/ServiceBulletinFilters';

export default function ServiceBulletinReportPage() {
    const { th } = useLanguage();

    const { items, totalCount, isFetching, lazyParams, onPage, activeFilters, handleFilterChange, resetFilters, sortField, sortOrder, onSort, handleAdvancedFilterApply, chassisNo } = useServiceBulletinReport();

    const columns = useMemo(() => getServiceBulletinColumns(th), [th]);

    return (
        <div className="card">
            <div className="mb-4">
                <h1 className="m-0">{th('serviceBulletinReport.title')}</h1>
            </div>

            <ServiceBulletinFilters onApplyFilters={handleAdvancedFilterApply} onResetFilters={resetFilters} />
            <div className="mt-3">
                <ServiceBulletinTable
                    items={items}
                    totalCount={totalCount}
                    loading={isFetching}
                    lazyParams={lazyParams}
                    onPage={onPage}
                    columns={columns}
                    sortField={sortField}
                    sortOrder={sortOrder}
                    onSortChange={onSort}
                    activeFilters={activeFilters}
                    onFiltersChange={handleFilterChange}
                    onResetFilters={resetFilters}
                    chassisNo={chassisNo}
                />
            </div>

            {!isFetching && items.length === 0 && (
                <div className="flex justify-content-center align-items-center p-5">
                    <p className="text-500">{th('common.noRecords')}</p>
                </div>
            )}
        </div>
    );
}
